import axios from 'axios';
import { getTenantCookie, getToken, getTokenCookie,removeAllCookies } from './auth';

export default function configureApiRestService() {
   axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
   axios.defaults.headers.common['Content-Type'] = 'application/json';
   axios.defaults.headers.common['Accept'] = 'application/json';
   axios.defaults.headers.common['X-Tenant'] = process.env.REACT_APP_CODE_TENANT;
   axios.defaults.headers.common['X-ClientId'] = process.env.REACT_APP_CLIENT_ID;
//   if (getToken() !== null) {
//       axios.defaults.headers.common['Authorization'] = 'Bearer ' + getToken();
//    } else if (getTokenCookie() !== null) {
//       axios.defaults.headers.common['Authorization'] = 'Bearer ' + getTokenCookie();
//    }
//    if (getTenantCookie() !== null) {      
//       axios.defaults.headers.common['X-Tenant'] =  getTenantCookie();
//    } 
//    axios.interceptors.request.use((config) => {
//       // Establece 'Content-Type: application/json' por defecto
   axios.interceptors.request.use((config) => {
      // Lee el token en cada request dinámicamente
      const token = getTokenCookie() || getToken();
      if (token) {
         config.headers['Authorization'] = 'Bearer ' + token;
      }

      const tenant = getTenantCookie();
      if (tenant) {
         config.headers['X-Tenant'] = tenant;
      }

      config.headers['Content-Type'] = 'application/json';
      // Si el cuerpo de la solicitud es un FormData, cambia el Content-Type a multipart/form-data
      if (config.data instanceof FormData) {
         config.headers['Content-Type'] = 'multipart/form-data';
                  // Si usas axios.defaults.headers['Content-Type'], será ignorado si lo configuras aquí, por lo que no necesitas eliminarlo
      }

      return config;
   }, (error) => {
      return Promise.reject(error);
   });

   axios.interceptors.response.use(function (response) {
      return response;
   }, function (error) {
            // Check if the request URL contains 'documentsxml'
      const isDocumentsXmlRequest = error.config && error.config.url && error.config.url.includes('documentsxml');
      
      if ((error.response.status == 401 || error.response.status == 403) && !isDocumentsXmlRequest) {
                  // Only show the session expired alert for non-documentsxml requests
                  removeAllCookies();
                    window.dispatchEvent(new Event('session-expired')); 
         alert("Sesión caducada, por favor vuelva a ingresar");
         window.location.href = process.env.REACT_APP_BASE_URL as string;
      } 
      else {
                  // For documentsxml requests or other errors, just reject the promise
         return Promise.reject(error);
      }
   });
}